/* eslint-disable */

jQuery(function ($) {
  // Variável para detectar se está arrastando
  let isDragging = false;
  let startX, startY;

  $('body').on('mousedown touchstart', '.faculty', function (e) {
    isDragging = false;
    const touch = e.type === 'touchstart' ? e.originalEvent.touches[0] : e;
    startX = touch.clientX || touch.pageX;
    startY = touch.clientY || touch.pageY;
  });

  $('body').on('mousemove touchmove', '.faculty', function (e) {
    if (startX !== undefined) {
      const touch = e.type === 'touchmove' ? e.originalEvent.touches[0] : e;
      const currentX = touch.clientX || touch.pageX;
      const currentY = touch.clientY || touch.pageY;
      const diffX = Math.abs(currentX - startX);
      const diffY = Math.abs(currentY - startY);

      // Se moveu mais de 10px, considera como arrasto
      if (diffX > 10 || diffY > 10) {
        isDragging = true;
      }
    }
  });

  $('body').on('click', '.faculty', function (e) {
    // Se estava arrastando, não abre o modal
    if (isDragging) {
      isDragging = false;
      return;
    }

    const facultyID = $(this).attr('data-id');
    $(`#${facultyID}`).show();
    $("body").css("overflow", "hidden");
  });

  $('body').on('mouseup touchend', '.faculty', function () {
    startX = undefined;
    startY = undefined;
  });

  $('body').on('click', '.faculty-modal--close', function () {
    $(this).parent().parent().parent().hide();
    $("body").removeAttr('style');
  });
});
